
import { defineComponent, PropType, computed } from '@nuxtjs/composition-api'
import { EmployerModel } from '~/model/Employer'

export default defineComponent({
  name: 'EmployerCard',
  props: {
    card: {
      type: Object as PropType<EmployerModel>,
      required: true
    }
  },
  setup(props) {
    const formattedNumbers = computed(() => {
      return props.card.numbers.map(item => item.number.replace('> ', '') + ' ' + item.text)
    })

    return { formattedNumbers }
  }
})
